import { render, staticRenderFns } from "./flag-fr.vue?vue&type=template&id=05dd1f2b"
import script from "./flag-fr.vue?vue&type=script&lang=js"
export * from "./flag-fr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports